let supportPostMessageObject = true;
try {
  window.postMessage(
    {
      toString: function () {
        supportPostMessageObject = false;
      },
    },
    '*',
  );
} catch (e) { }

export function postMessage(target: Window, message: object | string, targetOrigin: string = '*') {
  if (typeof message === 'object' && !supportPostMessageObject) {
    message = JSON.stringify(message);
  }
  // target.alert();
  target.postMessage(message, targetOrigin);
}

export function iceChildLinkTo(url: string) {
  if (self != top) {
    postMessage(window.top, {
      type: "goPage",
      data: url,
    }, '*')
  }
}

export function toThousands(_num: number): string {
  var num = (_num || 0).toString(),
    result = '';
  while (num.length > 3) {
    result = ',' + num.slice(-3) + result;
    num = num.slice(0, num.length - 3);
  }
  if (num) {
    result = num + result;
  }
  return result;
}


export function getDynamicDomain() {
  const domain = document.domain;
  if (domain.indexOf("gov.cn") != -1) {
    return "." + domain.split('.').slice(-3).join('.');

  } else {
    return window.location.hostname;
  }
}

export function isEmptyObject(obj: object) {
  let boolean = true;
  try {
    boolean = !Object.keys(obj).length;
  } catch (error) { }
  return boolean;
}

export function isNullOrUndef(v: any) {
  return v === null || typeof v === 'undefined';
}
